import {
  REQUEST_CASE_LINKS,
  RECEIVE_CASE_LINKS,
  ERROR_RETRIEVING_CASE_LINKS,
} from "typeConstants";
import { caseLinks as initialState } from "reducers/initialState.tsx";

const caseLinks = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CASE_LINKS:
      return {
        ...state,
        caseLinks: [],
        fetchingCaseLinks: true,
      };
    case RECEIVE_CASE_LINKS:
      return {
        ...state,
        caseLinks: action.payload,
        fetchingCaseLinks: false,
      };
    case ERROR_RETRIEVING_CASE_LINKS:
      return {
        ...state,
        caseLinks: [],
        fetchingCaseLinks: false,
      };
    default:
      return state;
  }
};

export default caseLinks;
